var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popups"},[_c('div',{staticClass:"popups-img"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}),_c('div',{staticClass:"closeBtn",on:{"click":_vm.closePopups}},[_c('img',{attrs:{"src":require("../../assets/popupClose.png"),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }